import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Callout } from '@/components/ui/callout'
import { useBooking } from '@/hooks/useSales'
import { formatEventDate } from '@/lib/eventTime'

/**
 * On a couple's event, a proposal waiting for them: where to review it and
 * until when (docs/sales.spec.md). Nothing when there isn't one, or it can't
 * be read; the page it links to says why.
 */
export function ProposalNotice({ eventId, planner }: { eventId: string; planner: boolean }) {
  const booking = useBooking(eventId)
  const open = booking.data?.packets.find((p) => (p.status === 'open' || p.status === 'signing') && !p.lapsed)
  if (booking.data === undefined || open === undefined) return null
  return (
    <Callout tone="neutral" title={planner ? `${booking.data.venueName} sent the couple a proposal` : `${booking.data.venueName} sent you a proposal`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span>
          For {formatEventDate(open.date)}, open until {formatEventDate(open.validUntil)}.
        </span>
        <Button asChild size="sm">
          <Link to={`/events/${eventId}/booking`}>{planner ? 'See the proposal' : 'Review your proposal'}</Link>
        </Button>
      </div>
    </Callout>
  )
}
